import PropTypes from 'prop-types';
import { getFormattedNumber } from 'utils/clickme';
import { INVOICE_PAYMENT_TYPE_BONUS } from 'utils/constants/admin';
import { NON_BREAKING_SPACE } from 'utils/constants/common';
import { VIEW_DATE_FORMAT } from 'utils/constants/date';
import { formatDate } from 'utils/date';

import Tip, { TipPlacement } from 'bloko/blocks/drop/Tip';
import HoverTip from 'bloko/blocks/drop/Tip/HoverTip';

import useTrls from 'hooks/translation/useTrls';

import Label from 'components/Label';

import Refund from 'components/Admin/InvoiceDetail/Payments/Payment/Refund';
import PayerType from 'components/Admin/Invoices/InvoicesTable/Invoice/Payer/PayerType';
import TableCell, { TableCellKind } from 'components/Table/TableCell';
import TableRow from 'components/Table/TableRow';

import { PaymentType } from 'store/models/invoices';

const Payment = ({ id, amount, createdAt, bonusAmount, paymentDate, paymentType, refunds }) => {
    const trl = useTrls();

    return (
        <TableRow>
            <TableCell kind={TableCellKind.Title}>{id}</TableCell>
            <TableCell>{formatDate(createdAt, VIEW_DATE_FORMAT)}</TableCell>
            <TableCell>
                <p>
                    {getFormattedNumber(amount)}
                    {NON_BREAKING_SPACE}
                </p>
                {bonusAmount > 0 && paymentType === INVOICE_PAYMENT_TYPE_BONUS && (
                    <HoverTip
                        placement={TipPlacement.Top}
                        render={() => <div>{trl('admin.Invoices.InvoicesTable.Invoice.bonus')}</div>}
                        host={document.body}
                        DropElement={Tip}
                    >
                        <p>
                            <Label type="secondary">{getFormattedNumber(bonusAmount)}</Label>
                        </p>
                    </HoverTip>
                )}
            </TableCell>
            <TableCell>{formatDate(paymentDate, VIEW_DATE_FORMAT)}</TableCell>
            <TableCell>{paymentType && <PayerType payerType={paymentType} />}</TableCell>
            <TableCell>
                {refunds?.map((refund) => (
                    <Refund key={refund.id} {...refund} />
                ))}
            </TableCell>
        </TableRow>
    );
};

Payment.propTypes = {
    id: PropTypes.number,
    amount: PropTypes.number,
    createdAt: PropTypes.string,
    bonusAmount: PropTypes.number,
    payer: PropTypes.string,
    paymentDate: PropTypes.string,
    paymentType: PropTypes.oneOf(Object.values(PaymentType)),
    refunds: PropTypes.array,
};

export default Payment;
